import { IWorkWithObjects } from "@vue-storefront/core/types/helpers/workWithObjects";

export const hasProperties = ({ object, properties, allPropertiesIsRequired = false }: IWorkWithObjects): boolean => {
  if (!object || typeof object !== "object") return false;

  if (!properties.length) return true;

  if (allPropertiesIsRequired) {
    return properties.every((prop) => prop in object);
  }

  return properties.some((prop) => prop in object);
}
